"use client";

import React from "react";

const NewsCarouselSkeleton: React.FC = () => {
  return (
    <div className="relative w-full px-6 py-4 dark:bg-gray-900">
      <div className="flex gap-4 overflow-hidden">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="flex animate-pulse items-center space-x-2 rounded-lg bg-white p-4 shadow-md dark:bg-gray-800"
          >
            {/* Image Skeleton */}
            <div className="h-[60px] w-[60px] rounded-md bg-gray-300 dark:bg-gray-700"></div>

            {/* Texte Skeleton */}
            <div className="flex w-full flex-col justify-center">
              <div className="h-4 w-32 rounded bg-gray-300 dark:bg-gray-700"></div>
              <div className="mt-2 h-3 w-24 rounded bg-gray-300 dark:bg-gray-700"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsCarouselSkeleton;
